<template>
  <div class="page-template add-page order-add-page">
    <div class="page-title">{{ title }}
    </div>
    <div class="btn-box">
      <el-button type="primary" plain @click="beBack">返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="audit" type="primary" plain :disabled="formModel.reviewerStatus != 20">审核</el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" ref="listOperationForm" :formOptions="listFormOptions"
                         @valueChange="listFormValueChange"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good">选择商品</el-button>
      <!--<el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>-->
      <!--<el-button @click="importData" type="primary" plain>导入商品</el-button>-->
      <el-button @click="openImport" type="primary" plain>导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800" v-if="componentsFlag"
               :close-on-click-modal="false">
      <good-list
        ref="goodsListOperation"
        v-if="listShow"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :tableOptions="tableOptions"
        @selectSubmit="rowsSelectSubmit"
        :otherParam="otherParam"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importShow" custom-class="importDialog" :close-on-click-modal="false">
      <import-template v-if="importShow" ref="importTemplate" :importShow="importShow"
                       @importFile="importData" @downTemplate="downloadTemplate"></import-template>
    </el-dialog>
  </div>
</template>
<script>
  //商品列表组件
  import goodList from '@/components/business/goodList';
  //添加要货单组件
  import listOperationNew from "@/components/template/listOperationNew";
  //要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';

  // 导入模版组件
  import importTemplate from '@/components/business/importTemplate';

  export default {
    components: {
      listOperationNew,
      goodList,
      listOperationForm,
      importTemplate
    },
    data() {
      return {
        importShow: false,
        isCheck: false,
        complexShow: true,
        goodsTxt: "",
        listTableData: [],
        otherParam: {statusList: [10, 20, 30]},
        goodListSelect: false,
        isSelectWarehouse: true,
        componentsFlag: true,
        selectUrl: {url: api.warehouse.warehouseGoods},
        title: '',
        listShow: false,
        goodList: [],
        formModel: {},
        dialogShow: false,
        // 添加头部字段
        //条件
        listFormOptions: {
          disabled: false,
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            }
          },
          labelWidth: '130px',
          columns:
            [
              {
                label: "库存调整来源",
                type: "select",
                prop: "relateType",
                data: this.$utils.getCacheStatus('weAdjustInventoryOrder.relateType'),
                defaultValue: this.$utils.getSysUser().storeId ? 20 : 10,
                hidden: true
              },
              {
                label: '业务单号',
                type: 'input',
                prop: 'orderNo',
                disabled: true,
                span: 8
              },
              {
                label: 'ID',
                type: 'input',
                prop: 'id',
                hidden: true,
              }, {
              label: "仓库",
              type: "warehouseInputDialog",
              prop: "warehouseId",
              change: this.getBatchOrder,
              url: api.warehouse.warehouse,
              param: {relateType: this.$utils.getSysUser().storeId ? 20 : 10},
              data: [],
              span: 8,
              disabled: false,
            },
              {
                label: "制单人",
                type: "input",
                prop: "voucherName",
                defaultValue: this.$utils.getSysUser().name,
                disabled: true,
                span: 8,
              },
              {
                label: "制单日期",
                type: "input",
                prop: "voucherDttm",
                defaultValue: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                disabled: true,
                span: 8,
              }, {
              label: '原因',
              type: 'select',
              prop: 'cause',
              defaultValue: 10,
              data: this.$utils.getCacheStatus('weAdjustInventoryOrder.cause'),
              span: 8,
              rule: [
                {required: true, message: "请选择原因", trigger: "blur"},
              ],
            }, {
              label: '出入库',
              type: 'select',
              prop: 'type',
              data: this.$utils.getCacheStatus('weAdjustInventoryOrder.type'),
              span: 8,
              rule: [
                {required: true, message: "请选择出入库", trigger: "blur"},
              ],
            }, {
              label: '备注',
              type: 'input',
              prop: 'remarks',
              span: 8,
            }]
        },
        // 添加表格字段
        listColumns: {
          disabled: false,
          indexShow: true,//是否显示索引
          summaryColumns: ['goodsNum', 'totalPrice'],
          columns: [
            {label: '操作', type: 'operation', width: 100, prop: 'operation'},
            {label: '序号', type: 'index', width: 60, prop: 'idx'},
            {
              label: '条码',
              prop: 'barCode',
              // type: 'input',
              width: '150',
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              align: 'center',
              width: '100'
            },
            {
              label: '规格',
              prop: 'specs',
              align: 'center',
              width: '60'
            },
            {
              label: '价格',
              prop: 'purchasePrice',
              align: 'center',
              width: '100'
            },
            // {
            //   label: '系统库存',
            //   prop: 'inventoryNum',
            //   align: 'center',
            //   width: '100'
            // },
            {
              label: '数量',
              prop: 'goodsNum',
              type: 'inputNumber',
              change: this.numChange,
              align: 'center',
              width: '100',
              precision: 2
            },
            {
              label: '小计金额',
              prop: 'totalPrice',
              align: 'center',
              width: '100'
            },
            {
              label: '备注',
              prop: 'remarks',
              align: 'center',
              type: 'input',
              width: '200'
            },

          ],
          url: api.warehouse.adjustInventory
        },
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '200',
              align: 'center'
            },
            {
              label: "品名",
              prop: "goodsName",
              width: "100",
              align: "center"
            },
            {
              label: "规格",
              prop: "specs",
              width: "100",
              align: "center"
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '200',
              align: 'center'
            },
            {
              label: '成本价',
              prop: 'purchasePrice',
              width: '150',
              align: 'center'
            },
          ],
          url: api.archives.goodsInfoIncludeSpecs,
          checkIndex: '',
        },
      }
    },
    created() {
      this.title = document.title + (this.$route.query.id ? '编辑' : '新增');
      this.$set(this.formModel, 'reviewerStatus', 10);
      if (this.$route.query.id) {
        this.getDetail();
      }else {
        this.$nextTick(() => {
          let warehouseId = this.$utils.getSysUser().warehouseId;
          this.$refs.listOperationForm.formModel.warehouseId = warehouseId;
          this.otherParam.warehouseId = warehouseId;
          this.isSelectWarehouse = false;
        })
      }
    },
    methods: {
      //点击 高级搜索显示
      complexFunc() {
        if (!this.isCheck) {
          this.complexShow = !this.complexShow;
        }
      },
      search() {
        if (this.goodsTxt === '' || this.goodsTxt === null) return;
        this.otherParam.otherName = this.goodsTxt;
        if (this.isSelectWarehouse) {
          this.goodsTxt = '';
          this.$confirm("请选择仓库！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else {
          this.isCheck = true;
          this.$axios
            .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
            .then(res => {
              if (res.code === 200) {
                if (res.data.length > 0) {
                  let tableData = res.data;
                  if (tableData.length === 1) {
                    let row = tableData[0];
                    let tableList = this.$refs["listOperation"].getTabelData();
                    let flag = true;
                    if (tableList.length > 0) {
                      tableList.forEach(item => {
                        if (flag) {
                          if (item.barCode === row.barCode) flag = false;
                        }
                      });
                    }
                    if (!flag) {
                      this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                      return;
                    }
                    row.goodsNum = '0.00';
                    row.totalPrice = '0.00';
                    // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                    this.$refs["listOperation"].setColumnData(row, tableList.length);
                    this.currentTableList = this.$refs["listOperation"].getTabelData();
                    this.$message.success("商品添加成功");
                  } else {
                    this.queryGoodsList();
                  }
                } else {
                  this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
                }
              } else {
                this.$message({type: "error", message: res.msg});
              }
            })
            .catch(err => {
            }).finally(() => {
            this.clearQueryParam();
            this.isCheck = false;
          });
        }
      },
      clearQueryParam() {
        this.goodsTxt = '';
        this.otherParam.otherName = '';
      },
      listFormValueChange(value, column) {
        if (column.prop == "warehouseId") {
          this.otherParam.warehouseId = value;
          this.isSelectWarehouse = false;
        }
      },
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.warehouse.adjustInventory + '?id=' + this.$route.query.id, {})
          .then(data => {
            this.loading = false;
            if (data.code == 200 && data.data) {
              this.formModel = data.data;
              this.isSelectWarehouse = false;
              this.otherParam.warehouseId = data.data['warehouseId'];
              if (this.formModel.reviewerStatus == 10) {
                this.listFormOptions.disabled = true;
                this.listColumns.disabled = true;
              }
              this.listFormOptions.columns.filter(item => item.prop === "warehouseId")[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === "type")[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === "cause")[0].disabled = true;
              this.$nextTick(() => {
                //为头部表单赋值
                this.$refs.listOperationForm.formModel = data.data;
                //为表格赋值
                this.$refs['listOperation'].addMoreRow(data.data.weAdjustGoodsMapMVOList, 0);
              });
            } else if (data.code == 200 && !data.data) {
              this.$message({message: '获取数据出错！', type: 'error'});
              this.$router.push({path: '/warehouse/inventory/goods'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },
      numChange(row, index) {
        if (row.retailPrice) {
          row.totalPrice = parseFloat(row.purchasePrice * row.goodsNum).toFixed(2);
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      //选择某行数据
      rowCheck(row) {
        this.listShow = false;
        row.goodsNum = '0.00';
        row.totalPrice = '0.00';
        this.$refs['listOperation'].setColumnData(row, this.checkIndex);
        this.listTableData = this.$refs["listOperation"].getTabelData();
      },
      rowsSelectSubmit(rows) {
        rows.map(row => {
          row.goodsNum = '0.00';
          row.totalPrice = '0.00';
        });
        let tableList = this.$refs['listOperation'].getTabelData();
        this.$refs['listOperation'].addMoreRow(rows, tableList.length);
        this.listTableData = this.$refs["listOperation"].getTabelData();
        this.listShow = false;
        this.componentsFlag = false;
        this.$nextTick(() => {
          this.componentsFlag = true
        });
        if (rows && rows.length > 0) {
          this.$message.success("商品添加成功");
        }
      },
      checkGoods() {
        if (this.isSelectWarehouse) {
          this.$confirm("请选择仓库!", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else {
          this.queryGoodsList();
        }
      },
      queryGoodsList() {
        this.listShow = true;
        this.goodListSelect = true;
        this.$nextTick(() => {
          this.listTableData = this.$refs["listOperation"].getTabelData();//table数据
        });
      },
      getBatchOrder(params) {
        // 选择商品前选中仓库
        this.isSelectWarehouse = false;
        // 选中商品组件查询条件
        this.otherParam.warehouseId = params.warehouseId;
        // 清除数据
        if (!this.$route.query.id) {
          this.$refs.listOperationForm.formModel.cause = "";
          this.$refs.listOperationForm.formModel.type = "";
          this.$refs['listOperation'].clearTableData();
        }
      },
      //提交数据
      submitAuth() {
        if (!this.isCheck) {
          let params = this.getParams();
          if (!params.warehouseId) {
            this.$confirm("请选择仓库！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            });
          } else if (!params.type) {
            this.$confirm("请选择出入库！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            });
          } else if (params.adjustGoodsMapList.length === 0) {
            this.$message({message: '商品信息无效', type: 'warning'});
          } else {
            let testSave = false
            testSave = params.adjustGoodsMapList.every(v => {
              if (v.goodsName && v.goodsNum && v.goodsNum !== 0
              ) {
                return true
              } else {
                return false
              }
            })
            if (testSave) {
              this.$confirm('是否保存数据，请确认?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                const loading = this.$loading({
                  lock: true,
                  text: '提交中，请稍候...',
                  background: 'rgba(225, 225, 225, 0.8)',
                });
                this.$axios
                  .fetchPost(api.warehouse.adjustInventory, params)
                  .then(data => {
                    this.loading = false;
                    if (data.code == 200 && data.data) {
                      this.$notify({
                        type: "success",
                        title: '提交操作',
                        message: '成功',
                        showClose: false,
                      });
                      // this.$message({message: '库存调整操作成功', type: 'success'});
                      this.$refs.listOperationForm.formModel = data.data;
                      this.$set(this.formModel, 'reviewerStatus', data.data.reviewerStatus);
                    } else {
                      this.$message({message: data.msg, type: 'error'});
                    }
                  }).catch(err => {
                  this.$notify({
                    type: "error",
                    title: '提交操作',
                    message: '失败',
                    showClose: false,
                  });
                  // this.$message({message: '请求失败！', type: 'error'});
                  this.loading = false;
                }).finally(() => {
                  loading.close()
                })
              })
            } else {
              this.$message({message: '商品数量不能为0或者空', type: 'warning'});
            }
          }
        }
      },
      addRequisition() {
        this.dialogShow = true;
      },
      //返回按钮事件
      beBack() {
        if (!this.isCheck) {
          this.$router.go(-1);
        }
      },
      refresh() {
        if (!this.isCheck) {
          this.$router.go(0);
        }
      },
      audit() {
        if (!this.isCheck) {
          let params = this.getParams();
          if (params.type) {
            this.$confirm('是否审核数据，请确认?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                const loading = this.$loading({
                  lock: true,
                  text: '提交中，请稍候...',
                  background: 'rgba(225, 225, 225, 0.8)',
                });
                this.$axios
                  .fetchPost(api.warehouse.adjustInventory + '/audit', params)
                  .then(data => {
                    this.loading = false;
                    if (data.code == 200 && data.data) {
                      this.dialogShow = false;
                      this.$notify({
                        type: "success",
                        title: '审核操作',
                        message: '成功',
                        showClose: false,
                      });
                      // this.$message({message: '审核成功', type: 'success'});
                      this.$router.push({path: '/warehouse/business'});
                    } else {
                      this.$message({message: data.msg, type: 'error'});
                    }
                  }).catch(err => {
                  this.$notify({
                    type: "error",
                    title: '审核操作',
                    message: '失败',
                    showClose: false,
                  });
                  // this.$message({message: '请求失败！', type: 'error'});
                  this.loading = false;
                }).finally(() => {
                  loading.close()
                })
              })
          } else {
            this.$message({message: '请选择出入库！', type: 'warning'});
          }
        }
      },
      getParams() {
        let tableList = this.$refs['listOperation'].getTabelData();
        let orderNumber = 1;
        tableList.map(item => {
          item.orderNumber = orderNumber++;
          if (item.goodsId == null) {
            item.goodsId = item.id;
          }
        });
        let totalParam = this.$refs['listOperation'].getSumData();
        let headParam = this.$refs.listOperationForm.getFormModel();

        return {
          ...{adjustGoodsMapList: tableList}, ...totalParam, ...headParam
        };
      },
      downloadTemplate() {
        if (!this.isCheck) {
          this.$axios.fetchPost(api.warehouse.downloadTemplate).then(data => {
            if (data.code === 200) {
              const elink = document.createElement('a');
              elink.href = data.data;
              elink.click();
              this.loadingExt = false;
              this.$notify({
                type: "success",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出成功', type: 'success'});
            } else {
              this.$notify({
                type: "error",
                title: '导出操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '导出异常', type: 'error'});
            }
          })
        }
      },
      // 导入数据
      importData() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.warehouseId) {
            this.$utils.uploadFile((file) => {
              this.loading = true;
              let formData = new FormData();
              formData.append('multipartFile', file);
              formData.append('warehouseId', tableData.warehouseId);
              this.$refs['listOperation'].clearTableData();
              const loading = this.$loading({
                lock: true,
                text: '提交中，请稍候...',
                background: 'rgba(225, 225, 225, 0.8)',
              });
              this.$axios
                .fetchPostGoodsExport(api.warehouse.warehouseImportGoods, formData)
                .then(data => {
                  if (data.code === 200) {
                    this.importShow = false;
                    //为表格赋值
                    if (data.data.weWarehouseGoodsMapMVOList) {
                      data.data.weWarehouseGoodsMapMVOList.map(item => {
                        item.id = item.goodsId;
                        item.goodsNum = item.blitemNum;
                        item.totalPrice = (item.purchasePrice * item.goodsNum).toFixed(2);
                      });
                      this.$refs['listOperation'].addMoreRow(data.data.weWarehouseGoodsMapMVOList, 0);
                      this.listTableData = this.$refs["listOperation"].getTabelData();
                    }
                    if (data.data.errorBatchId) {
                      this.exportErrorData(data.data.errorBatchId);
                    }
                  } else {
                    if (data.errorMsg) {
                      this.$message({message: data.errorMsg, type: "error"});
                    } else {
                      this.$notify({
                        type: "error",
                        title: '导出操作',
                        message: '失败',
                        showClose: false,
                      });
                      // this.$message({message: "导入异常", type: "error"});
                    }
                  }
                })
                .finally(() => {
                  loading.close()
                })
            });
          } else {
            this.$message({message: '请选择仓库！', type: 'warning'});
          }
        }
      },
      // 导入的错误数据
      exportErrorData(id) {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.PostBlob(api.system.exportError + '?batchId=' + id, '').then(res => {
          if (res.status === 200) {
            const fileName = '库存调整错误数据' + '_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      openImport() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.warehouseId) {
            this.importShow = true;
          } else {
            this.$message.warning("请选择仓库")
          }
        }
      },
    }

  }
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }

  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }
</style>



// WEBPACK FOOTER //
// src/page/warehouse/BusinessAdd.vue